export default {
	name: 'Dropdown',
	props: {
		size: {
			type: String,
			default: 'medium',
		},
		label: {
			type: String,
			default: '',
		},
		nullable: {
			type: Boolean,
			default: false,
		},
		options: {
			type: Object,
			default: () => ({}),
		},
		selectedProp: {
			type: [Number, String, Array],
			default: null,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	computed: {
		normalizedSelected() {
			if (!this.multiple) {
				return this.selectedProp;
			}

			return Array.isArray(this.selectedProp)
				? this.selectedProp.map(String)
				: [];
		},
		selectedLabels() {
			if (!this.multiple || !Array.isArray(this.selectedProp)) {
				return [];
			}

			return Object.entries(this.options)
				.filter(([, key]) => this.normalizedSelected.includes(String(key)))
				.map(([value]) => this.$t(value) || value);
		},
		selectedLabelsText() {
			if (this.selectedLabels.length === 0) {
				return this.label;
			}

			return this.selectedLabels.join(', ');
		},
	},
	methods: {
		handleInput(e) {
			const value = e.target.value === 'null' ? null : e.target.value;
			this.$emit('update:modelValue', value);
		},
		toggleDropdown() {
			this.isOpen = !this.isOpen;
		},
		closeDropdown() {
			this.isOpen = false;
		},
		isSelected(key) {
			return this.normalizedSelected.includes(String(key));
		},
		toggleOption(key) {
			const keyString = String(key);
			const current = [...this.normalizedSelected];

			const exists = current.includes(keyString);

			const updated = exists
				? current.filter(item => item !== keyString)
				: [...current, keyString];

			this.$emit('update:modelValue', updated);
		},
		handleClickOutside(event) {
			if (!this.$refs.dropdown) {
				return;
			}

			if (!this.$refs.dropdown.contains(event.target)) {
				this.closeDropdown();
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	},
};